import React, { useEffect, useState } from 'react';
import { Search, Filter, FileSpreadsheet, File as FilePdf, AudioLines, ImagePlayIcon, Loader2, FileText, MessageCircle } from 'lucide-react';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import ConfirmDialog from '../../components/confirmDialog';
import { GET_DATA } from '../../services/API';
import { formatDateToPtBrDateTime, parseLocalDate } from '../../utils';
import UserSummaryModal from './userSummaryModal';
import autoTable from 'jspdf-autotable';
import { AudioListModal } from '../../components/audioListModal';
import { useSelector } from 'react-redux';
import ImageListModal from '../../components/imageListModal';
import MessageListModal from '../../components/messageListModal';

const GestaoUsuarios = () => {
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [showFilters, setShowFilters] = useState(false);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [showSummaryModal, setShowSummaryModal] = useState(false);
    const [showAudios, setShowAudios] = useState(false);
    const [showImages, setShowImages] = useState(false);
    const [showMessages, setShowMessages] = useState(false);
    const [selectedUserSummary, setSelectedUserSummary] = useState('');
    const [filters, setFilters] = useState({
        status: 'all',
        assistantId: '2', //NextRun
        weightRange: { min: 0, max: 200 },
        heightRange: { min: 0, max: 3 },
        distanceRange: { min: 0, max: 1000 },
        weightLossRange: { min: 0, max: 100 },
        dateRange: { start: '', end: '' },
        gender: 'all'
    });

    const authentication = useSelector((state) => state.authentication);

    const [assistants, setAssistants] = useState([{ id: 'all', assistantId: '', label: 'Todos', disabled: true }]);

    const [externalReference, setExternalReference] = useState('');

    useEffect(() => {
        (async () => {
            try {
                setIsLoading(true);

                //Buscar usuário
                const dados = await GET_DATA(`ChatCompletionAPI/GetchatCompletionAPIByFilter?externalReference=&assistantId=0&flgSomenteAtivos=false`);

                const dadosFinais = dados.data.filter(a => a.summary?.length > 0);

                setUsers(dadosFinais);

                await fetchAssistants();
            } catch (error) {
                console.error('Error loading users:', error);
            }
            finally {
                setIsLoading(false);
            }
        })();
    }, []);

    const fetchAssistants = async () => {
        const result = await GET_DATA('Assistant/GetAllAssistantBasicData?flgActive=true');

        if (result !== null) {
            const options = [];

            result.data.map(item => {
                if (authentication.user?.login === 'fCamilo' && item.id === 2) {
                    options.push({
                        id: item.id,
                        label: item.name,
                        assistantId: item.assistantId,
                        disabled: false
                    });
                }
                else if (authentication.user?.login === 'admin') {
                    options.push({
                        id: item.id,
                        label: item.name,
                        assistantId: item.assistantId,
                        disabled: false
                    });
                }
            })


            setAssistants([{ id: 0, assistantId: '', label: 'Selecione um agente', disabled: true }, ...options]);
        }
    }

    const itemsPerPage = 10;

    const confirmDelete = () => {
        if (userToDelete) {
            setUsers(users.filter(user => user.Id !== userToDelete));
            setUserToDelete(null);
            setShowDeleteConfirm(false);
        }
    };

    const exportToExcel = () => {
        const dados = users.map(item => { delete item.chatCompletionAPIJson; return item; });

        const ws = XLSX.utils.json_to_sheet(dados);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Interações usuários");
        XLSX.writeFile(wb, "users.xlsx");
    };

    const exportToPDF = () => {
        const doc = new jsPDF();
        const tableColumn = ["Usuário", "Celular", "Data última  interação", "Assistente", "Situação", "Resumo"];
        const tableRows = users.map(user => [
            user.nomeUsuario,
            user.externalReference,
            user.dateUpdate,
            user.assistantName,
            user.flgActive ? 'Ativo' : 'Inativo',
            user.summary
        ]);

        doc.text("Relatório de Interações usuários", 14, 15);
        autoTable(doc, {
            head: [tableColumn],
            body: tableRows,
            startY: 20
        });

        doc.save("users.pdf");
    };

    const filteredUsers = users.filter(user => {
        const matchesSearch = user.externalReference.toLowerCase().includes(searchTerm.toLowerCase());

        const matchesStatus = filters.status === 'all' ||
            (filters.status === 'active' && user.flgActive) ||
            (filters.status === 'inactive' && !user.flgActive);

        const matchesAssistant = filters.assistantId === 'all' || (filters.assistantId == user.assistantAIId);

        let matchesDate = true;
        if (filters.dateRange.start && filters.dateRange.end) {
            const eventDate = new Date(user.dateUpdate || '');
            const start = new Date(parseLocalDate(filters.dateRange.start));
            const end = new Date(parseLocalDate(filters.dateRange.end));
            end.setHours(23, 59, 59, 999);

            matchesDate = eventDate >= start && eventDate <= end;
        }

        return matchesSearch && matchesStatus && matchesDate && matchesAssistant;
    });

    const paginatedUsers = filteredUsers.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

    return (
        <div className="p-6 space-y-6">
            <div className="flex justify-between items-center">
                <h1 className="text-2xl font-bold text-gray-800 dark:text-white">Interações dos usuários</h1>
                <div className="flex gap-2">
                    <button
                        onClick={exportToExcel}
                        className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
                    >
                        <FileSpreadsheet className="w-4 h-4 mr-2" />
                        Excel
                    </button>
                    <button
                        onClick={exportToPDF}
                        className="flex items-center px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
                    >
                        <FilePdf className="w-4 h-4 mr-2" />
                        PDF
                    </button>
                </div>
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden">
                <div className="p-6 border-b border-gray-200 dark:border-gray-700">
                    <div className="flex flex-col sm:flex-row gap-4 items-center">
                        <div className="w-64">
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                                Assistente
                            </label>
                            <select
                                value={filters.assistantId}
                                onChange={(e) => setFilters({ ...filters, assistantId: e.target.value })}
                                className="w-full bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 dark:text-white rounded-lg px-3 py-2"
                            >
                                {
                                    assistants.map(item => {
                                        return <option value={item.id}>{item.label}</option>
                                    })
                                }
                            </select>
                        </div>
                        <div className="flex-1 mt-7">
                            <div className="flex items-center gap-2 bg-gray-100 dark:bg-gray-700 rounded-lg px-4 py-2">
                                <Search className="w-5 h-5 text-gray-500" />
                                <input
                                    type="text"
                                    placeholder="Buscar interações de usuários..."
                                    className="bg-transparent border-none w-full focus:outline-none text-gray-700 dark:text-gray-200 "
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                        </div>
                        <button
                            onClick={() => setShowFilters(!showFilters)}
                            className={`flex items-center gap-2 px-4 py-2 mt-7 rounded-lg ${showFilters
                                ? 'bg-[#feca40] text-white'
                                : 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200'
                                }`}
                        >
                            <Filter className="w-5 h-5" />
                            Filtros
                        </button>
                    </div>

                    {showFilters && (
                        <div className="mt-4 p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
                            <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 gap-2">
                                <div className='w-[100%]'>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                                        Status
                                    </label>
                                    <select
                                        value={filters.status}
                                        onChange={(e) => setFilters({ ...filters, status: e.target.value })}
                                        className="w-full bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 dark:text-white rounded-lg px-3 py-2"
                                    >
                                        <option value="all">Todos</option>
                                        <option value="active">Ativos</option>
                                        <option value="inactive">Inativos</option>
                                    </select>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                                        Período
                                    </label>
                                    <div className="flex gap-2">
                                        <input
                                            type="date"
                                            value={filters.dateRange.start}
                                            onChange={(e) => setFilters({
                                                ...filters,
                                                dateRange: { ...filters.dateRange, start: e.target.value }
                                            })}
                                            className="w-full bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 dark:text-white rounded-lg px-3 py-2"
                                        />
                                        <input
                                            type="date"
                                            value={filters.dateRange.end}
                                            onChange={(e) => setFilters({
                                                ...filters,
                                                dateRange: { ...filters.dateRange, end: e.target.value }
                                            })}
                                            className="w-full bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 dark:text-white rounded-lg px-3 py-2"
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>
                    )}
                </div>

                <div className="overflow-x-auto">
                    <table className="w-full">
                        <thead className="bg-gray-50 dark:bg-gray-900">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-white">
                                    Usuário
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-white">
                                    Celular
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-white">
                                    Data última interação
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-white">
                                    Assistente
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-white">
                                    Situação
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-white">
                                    Resumo
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                            {isLoading ? (
                                <tr>
                                    <td colSpan={7} className="px-6 py-4 text-center">
                                        <div className="flex items-center justify-center">
                                            <Loader2 className="w-6 h-6 text-gray-400 animate-spin" />
                                            <span className="ml-2 text-gray-600 dark:text-gray-400">Carregando interações dos usuários...</span>
                                        </div>
                                    </td>
                                </tr>
                            ) : paginatedUsers.length === 0 ? (
                                <tr>
                                    <td colSpan={7} className="px-6 py-4 text-center text-gray-500 dark:text-gray-400">
                                        Nenhum usuário encontrado
                                    </td>
                                </tr>
                            ) : paginatedUsers.map((user) => (
                                <tr key={user.Id}>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">
                                        {user.nomeUsuario ? user.nomeUsuario : "-"}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">
                                        {user.externalReference}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">
                                        {formatDateToPtBrDateTime(user.dateUpdate)}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">
                                        {user.assistantName}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">
                                        {user.flgActive ? 'Ativo' : 'Inativo'}
                                    </td>
                                    <td className="px-6 py-4 text-sm text-gray-900 dark:text-gray-100">
                                        <div className="flex items-center justify-center space-x-2">
                                            <button
                                                onClick={() => {
                                                    setSelectedUserSummary(user.summary);
                                                    setShowSummaryModal(true);
                                                }
                                                }
                                                className="flex items-center px-4 py-2 bg-black text-white rounded-lg hover:bg-red-700"
                                            >
                                                <FileText className="w-4 h-4 mr-2" />Resumo
                                            </button>

                                            <button
                                                onClick={() => {
                                                    setExternalReference(user.externalReference);
                                                    setShowAudios(true);
                                                }
                                                }
                                                className="flex items-center px-4 py-2 bg-black text-white rounded-lg hover:bg-red-700"
                                            >
                                                <AudioLines className="w-4 h-4 mr-2" />Áudios
                                            </button>

                                            <button
                                                onClick={() => {
                                                    setExternalReference(user.externalReference);
                                                    setShowImages(true);
                                                }
                                                }
                                                className="flex items-center px-4 py-2 bg-black text-white rounded-lg hover:bg-red-700"
                                            >
                                                <ImagePlayIcon className="w-4 h-4 mr-2" />Imagens
                                            </button>

                                            <button
                                                onClick={() => {
                                                    setExternalReference(user.externalReference);
                                                    setShowMessages(true);
                                                }
                                                }
                                                className="flex items-center px-4 py-2 bg-black text-white rounded-lg hover:bg-red-700"
                                            >
                                                <MessageCircle className="w-4 h-4 mr-2" />Mensagens
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="p-4 border-t border-gray-200 dark:border-gray-700 flex items-center justify-between">
                    <span className="text-sm text-gray-700 dark:text-gray-300">
                        Página {currentPage} de {totalPages}
                    </span>
                    <div className="flex gap-2">
                        <button
                            onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                            disabled={currentPage === 1}
                            className="px-3 py-1 border border-gray-300 dark:border-gray-600 rounded-lg disabled:opacity-50 dark:text-white"
                        >
                            Anterior
                        </button>
                        <button
                            onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                            disabled={currentPage === totalPages}
                            className="px-3 py-1 border border-gray-300 dark:border-gray-600 rounded-lg disabled:opacity-50 dark:text-white"
                        >
                            Próxima
                        </button>
                    </div>
                </div>
            </div>

            <ConfirmDialog
                isOpen={showDeleteConfirm}
                onClose={() => setShowDeleteConfirm(false)}
                onConfirm={confirmDelete}
                title="Confirmar Exclusão"
                message="Tem certeza que deseja excluir este usuário? Esta ação não pode ser desfeita."
            />

            <UserSummaryModal
                isOpen={showSummaryModal}
                onClose={() => setShowSummaryModal(false)}
                summary={selectedUserSummary}
            />

            {
                externalReference &&
                <AudioListModal
                    isOpen={showAudios}
                    onClose={() => setShowAudios(false)}
                    assistantId={filters.assistantId}
                    externalReference={externalReference}
                />
            }

            {
                externalReference &&
                <ImageListModal
                    isOpen={showImages}
                    onClose={() => setShowImages(false)}
                    assistantId={filters.assistantId}
                    externalReference={externalReference}
                />
            }

            {
                externalReference &&
                <MessageListModal
                    isOpen={showMessages}
                    onClose={() => setShowMessages(false)}
                    assistantId={filters.assistantId}
                    externalReference={externalReference}
                />
            }
        </div>
    );
}

export default GestaoUsuarios;